import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { formatToDateTime } from "../main/formatToDateTime";
import { Link } from "react-router-dom";
import * as html2pdf from "html2pdf.js";

export default function DeliveryTallySheet() {
  const pdfRef = useRef();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [Data, setData] = useState(null);

  const fetchData = async (id) => {
    setLoading(true);
    const url = `https://ctas.live/backend/api/get/tally/delivery/${id}`;
    try {
      const response = await axios.get(url);
      if (response?.data?.status === "success") {
        setData(response?.data?.data);
      } else {
        Swal.fire({
          icon: response?.data?.status,
          text: response?.data?.message,
          timer: 3000,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error Fetching Data: ${error.message}`,
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const id = searchParams.get("id");
    if (id) {
      fetchData(id);
    }
  }, [searchParams]);

  const [cclsPackages, setCclsPackages] = useState(0);
  const [totalPackages, setTotalPackages] = useState(0);
  const [totalPackagesWeight, setTotalPackagesWeight] = useState(0);
  const [totalArea, setTotalArea] = useState(0);

  const today = new Date();
  const formattedDate = today.toLocaleDateString("en-GB");

  useEffect(() => {
    if (Data && Data.delivery_trucks) {
      let cclsPackages = 0;
      let totalPackages = 0;
      let totalPackagesWeight = 0;
      let totalArea = 0;

      const truckBoeSet = new Set(
        Data.delivery_trucks.map((truck) => truck.boe)
      );
      const filteredDetails = Data.delivery_bill_details.filter(
        (details) =>
          truckBoeSet.has(details.boe_number) ||
          truckBoeSet.has(details.bol_number)
      );

      filteredDetails.forEach((details) => {
        cclsPackages += parseInt(details.no_of_packages_declared ?? 0);
      });

      Data.delivery_trucks.forEach((Details) => {
        totalPackages += parseInt(Details.no_of_pkgs ?? 0);
        totalPackagesWeight += parseFloat(Details.pkgs_weight ?? 0);
        // totalArea += parseFloat(Details.area_m ?? 0);
        Details?.grid_area?.map(
          (grid_area) => (totalArea += parseFloat(grid_area.area ?? 0))
        );
      });
      setCclsPackages(cclsPackages);
      setTotalPackages(totalPackages);
      setTotalPackagesWeight(totalPackagesWeight);
      setTotalArea(totalArea);
    }
  }, [Data]);
  const handleDownload = () => {
    const element = pdfRef.current;

    const opt = {
      margin: [0.2, 0.2, 0.2, 0.2], // top, left, bottom, right in inches
      filename: "Tally Sheet.pdf",
      image: { type: "jpeg", quality: 1 },
      html2canvas: {
        scale: 3, // Higher scale = better quality
        useCORS: true, // fixes image loading issue
      },
      jsPDF: {
        unit: "in",
        format: "a3", // standard A4
        orientation: "portrait",
      },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] }, // try to avoid breaking elements
    };

    html2pdf().set(opt).from(element).save();
  };

  if (!Data) {
    return (
      <div className="container mt-10">
        <div className="d-flex justify-content-center">
          <div className=" w-100 alert alert-danger" role="alert">
            No data received yet.
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            {[...Array(6)].map((_, index) => (
              <div key={index} className="sk-chase-dot" />
            ))}
          </div>
        </div>
      )}
      <div className="col-lg-11 my-3 mx-auto">
        <div className="card tally_sheet shadow-none" ref={pdfRef}>
          <div className="card-body">
            <div className="row">
              <div className="col">
                <span> S.No:</span> <b> {Data.id}</b>
                <br />
                <span>Date: </span> <b>{formattedDate}</b>
              </div>
              <div className="col text-center">
                <b>Cargo Handling Operator </b>
                <br />
                <span>Container Delivery Tally Sheet</span>
              </div>
              <div className="col text-end">
                <Link
                  to="/import-reports"
                  className="btn btn-label-primary waves-effect waves-light me-1"
                >
                  <i className="ri-arrow-left-line ri-20px" />
                </Link>
                {/* <button
                  onClick={() => window.print()}
                  className="btn btn-label-info"
                >
                  Print
                </button> */}
                <button
                  onClick={handleDownload}
                  className="btn btn-label-info ms-1"
                >
                  <i className="ri-download-fill ri-22px"></i>
                </button>
              </div>
            </div>
            <hr />
            <div className="row px-10 top">
              <table className="table table-borderless mb-4 table-font text-nowrap text-align-start">
                <tbody>
                  <tr>
                    <td className="text-start px-10">GPM Number</td>
                    <td className="text-start px-10">
                      <strong>: {Data.gpm_number}</strong>
                    </td>
                    <td className="text-start px-10">Total No Of Trucks</td>
                    <td className="text-start px-10">
                      <strong>: {Data?.delivery_trucks?.length}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-start px-10">Bill Of Entry</td>
                    <td className="text-start px-10">
                      <strong>
                        :
                        {Data?.delivery_bill_details?.map((details, i) => (
                          <>
                            <span>{details.boe_number}, </span>
                            {(i + 1) % 3 === 0 && <br />}
                          </>
                        ))}
                      </strong>
                    </td>
                    <td className="text-start px-10">Sline Code</td>
                    <td className="text-start px-10">
                      <strong>: {Data.shipping_line_code}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-start px-10">Container Number</td>
                    <td className="text-start px-10">
                      <strong>: {Data.container_number}</strong>
                    </td>
                    <td className="text-start px-10">Declared Gross Weight</td>
                    <td className="text-start px-10">
                      <strong>: {Data.gross_weight} Tons</strong>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-start px-10">Container Size</td>
                    <td className="text-start px-10">
                      <strong>: {Data.container_size}</strong>
                    </td>
                    <td className="text-start px-10">Start Date & Time</td>
                    <td className="text-start px-10">
                      <strong>
                        :{Data.start_time && formatToDateTime(Data.start_time)}
                      </strong>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-start px-10">Cha Code</td>
                    <td className="text-start px-10">
                      <strong>: {Data.cha_code}</strong>
                    </td>
                    <td className="text-start px-10"> End Date & Time</td>
                    <td className="text-start px-10">
                      <strong>
                        :{Data.end_time && formatToDateTime(Data.end_time)}
                      </strong>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-start px-10">
                      Total No. of Packages Declared
                    </td>
                    <td className="text-start px-10">
                      <strong>: {cclsPackages}</strong>
                    </td>
                    <td className="text-start px-10">
                      Excess / Short Packages
                    </td>
                    <td className="text-start px-10">
                      <strong>
                        : {Math.max(0, cclsPackages - totalPackages)}{" "}
                      </strong>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-start px-10">Handling Type</td>
                    <td className="text-start px-10">
                      <strong>:{Data.handling_type}</strong>
                    </td>
                    <td className="text-start px-10">
                      {Data.type === "LCL" ? "Forwarder" : "Importer"} Name
                    </td>
                    <td className="text-start px-10">
                      <strong>:{Data.importer_name}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="row main">
              <table className="table table-bordered table-font">
                <thead className="">
                  <tr>
                    <th>Truck Number</th>
                    <th>Bill of Entry No</th>
                    <th>Pkg Code</th>
                    <th>Cargo Description (Code)</th>
                    <th>No of Pkgs</th>
                    <th>Pkg Weight</th>
                    <th>Grid Locations</th>
                    <th>Area (Sqm)</th>
                  </tr>
                </thead>
                <tbody>
                  {Data.delivery_trucks &&
                    Data.delivery_trucks.map((Trucks, k) => (
                      <tr key={k}>
                        <td>{Trucks.truck_number}</td>
                        <td>{Trucks.boe}</td>
                        <td>{Trucks.pkg_code}</td>
                        <td>{Trucks.cargo_description}</td>

                        <td>{Trucks.no_of_pkgs}</td>
                        <td>{Trucks.pkgs_weight}</td>
                        <td>
                          {Trucks?.grid_area?.map((grid_area) => (
                            <span>{grid_area.grid_locations} ,</span>
                          ))}
                        </td>
                        <td>
                          {Trucks?.grid_area?.map((grid_area) => (
                            <span>{grid_area.area} ,</span>
                          ))}
                        </td>
                      </tr>
                    ))}

                  {Data.delivery_trucks
                    ? Array.from(
                        {
                          length: Math.max(0, 10 - Data.delivery_trucks.length),
                        },
                        (_, i) => (
                          <tr key={i}>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                        )
                      )
                    : Array.from({ length: 10 }, (_, i) => (
                        <tr key={i}>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      ))}

                  <tr>
                    <td>Total</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{totalPackages}</td>
                    <td>
                      {totalPackagesWeight
                        ? Number(totalPackagesWeight).toFixed(2)
                        : 0}{" "}
                      Tons
                    </td>

                    <td></td>
                    <td>{totalArea}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="row border" style={{ height: "150px" }}>
              <div className="col-md-12">
                <p>
                  <b>Remarks : </b>
                  <span> </span>
                </p>
              </div>
            </div>
            <div
              className="row mt-1 align-items-end"
              style={{ height: "130px" }}
            >
              <div className="col">
                <span>
                  Said to contain received cargo in sound condition and to my
                  entire satisfaction.
                </span>
              </div>
              <div className="col text-center">
                <span>Tallied By</span> <br />
                <b>--</b>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
